module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"little":"Little Finger","ring":"Ring Finger","middle":"Middle Finger","index":"Index Finger","thumb":"Thumb"},"es":{"index":"Hombre","feindex":"Mujer"},"sw":{"index":"Mwanaume","feindex":"Mwanamke"}}')
  delete Component.options._Ctor
}
